module.exports = __webpack_public_path__ + "static/media/close.5c14c216.svg";